import { LocalUser } from '@/shared/lib/db'
import { create } from 'zustand'

interface AuthState {
    user: LocalUser | null
    loading: boolean
    needsOnboarding: boolean
    setUser: (user: LocalUser | null) => void
    setLoading: (loading: boolean) => void
    setNeedsOnboarding: (needsOnboarding: boolean) => void
}

export const useAuthStore = create<AuthState>((set) => ({
    user: null,
    loading: true,
    needsOnboarding: false,
    setUser: (user) => set({ user }),
    setLoading: (loading) => set({ loading }),
    setNeedsOnboarding: (needsOnboarding) => set({ needsOnboarding }),
}))

// Export a hook that mimics the old API for easier refactoring
export const useAuth = () => {
    const { user, loading, needsOnboarding } = useAuthStore()
    return { user, loading, needsOnboarding }
}
